<template>
  <div id="borrowing">
    <navmenu></navmenu>
    <div class="content">
      <div class="top">
        <div class="left">
          <div class="topTitle">Simple、Quick 、Secure Loan Process</div>
          <div class="vagueIcon">
            <img src="@/assets/vagueIcon.png" alt="" />
          </div>
          <ul>
            <li>
              <p class="number">01</p>
              <div>
                <p class="title">Registration</p>
                <p class="introduce">
                  Download Support and fill in your personal information.
                </p>
              </div>
            </li>
            <li>
              <p class="number">02</p>
              <div>
                <p class="title">Auditing</p>
                <p class="introduce">
                  The system will automatically review the information you
                  provide.
                </p>
              </div>
            </li>
            <li>
              <p class="number">03</p>
              <div>
                <p class="title">Disbursement</p>
                <p class="introduce">
                  Once the loan application is approved, the funds will be
                  transferred to the designated bank account immediately.
                </p>
              </div>
            </li>
            <li>
              <p class="number">04</p>
              <div>
                <p class="title">Repayment</p>
                <p class="introduce">
                  Follow the repayment instructions in the app and pay your
                  bills on time to maintain good credit.
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="dialog">
            <p class="text">
              Authorization and supervision safely and securely by SEC
            </p>
            <div class="rp">
              <p>Maximum loan amount</p>
              <img src="@/assets/phpAmount.png" alt="" />
            </div>
            <div class="jiantou">
              <img src="@/assets/arrowIcon.png" alt="" />
            </div>
          </div>
          <div class="get">
            <img src="@/assets/google.png" alt="" />
            <img src="@/assets/appStore.png" alt="" />
          </div>
          <div class="footer">
            <p>Supervisory organization</p>
            <img src="@/assets/organ.png" alt="" />
          </div>
        </div>
      </div>
      <div class="advantage">
        <div class="title">
          <p>Our Advantage</p>
          <img src="@/assets/logo.png" alt="" />
        </div>
        <div class="box">
          <ul>
            <li>
              <p class="boxTitle">Simple application process</p>
              <p class="boxContent">
                Just show your ID and go through 3 steps to apply for a loan.
              </p>
            </li>
            <li>
              <p class="boxTitle">Quick disbursement</p>
              <p class="boxContent">
                Fast 3-minute review and quick disbursement.
              </p>
            </li>
            <li>
              <p class="boxTitle">High Loan Amounts</p>
              <p class="boxContent">Unsecured loan up to 30,000 pesos.</p>
            </li>
            <li>
              <p class="boxTitle">Transparent costs</p>
              <p class="boxContent">No hidden costs.</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="loanProduct">
        <div class="left">
          <div class="title">Our Loan Products</div>
          <div
            style="
              font-size: 20px;
              font-weight: bold;
              font-family: Poppins, Poppins;
              color: #5931f4;
            "
          >
            <p>
              <span style="font-family: Poppins Bold">Smart </span> and easy
              applications to meet your needs
            </p>
          </div>
          <div class="choose">
            On the support platform, we provide a variety of products for you to
            choose.
          </div>
          <div class="icon">
            <img src="@/assets/peso.png" alt="" />
            <span>Peso Support</span>
            <img src="@/assets/support.png" alt="" />
            <span>Support</span>
            <img src="@/assets/loan.png" alt="" />
            <span>Support Loan</span>
          </div>
          <div class="more">More applicaitons are on the way...</div>
        </div>
        <div class="right">
          <img class="quick" src="@/assets/circleBg.png" alt="" />
          <img class="mobile" src="@/assets/mobile.png" alt="" />
          <p>Support</p>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <img class="logo" src="@/assets/logo.png" alt="" />
          <p style="font-size: 18px">Providing reliable financial services</p>
          <div class="title">
            <p>Address</p>
            <p style="margin-left: 280px">Need help</p>
          </div>
          <div style="margin-top:15px">
            <img
              @click="openAddress"
              style="width: 38px; height: 38px; cursor: pointer; display: block"
              src="@/assets/addressIcon.png"
              alt=""
            />
          </div>
          <div class="about">
            <p style="margin-right: 110px">
              <span style="white-space: pre">Address:</span>
              <br />
              2806 Trade and Financial Tower， Lane Q，Bonifacio Global City，
              Taguig City，Philippines
            </p>
            <p>
              Contact us
              <br />
              Monday to Friday 8:00-18:00
              <br />
              Email: info@excellentrealending.com
              <br />
              Call center: +63 9065241087
            </p>
          </div>
          <p
            style="
              color: #fff;
              font-size: 14px;
              margin-top: 46px;
              font-family: PingFangSC, PingFang SC;
            "
          >
            Support belongs to EXCELLENT ERA LENDING SERVICE CORP.
          </p>
        </div>
        <div class="right">
          <p>Download the app now!</p>
          <div class="rightImg">
            <img style="margin-bottom: 35px" src="@/assets/google.png" alt="" />
            <img src="@/assets/appStore.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'borrowing',
  data () {
    return {}
  },
  methods: {
    openAddress () {
      window.open('https://maps.app.goo.gl/s8Q5Z3yHPxDF5baK8')
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  background-image: url("~@/assets/eelendingBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-bottom: 230px;
  .top {
    width: 1220px;
    padding-top: 93px;
    display: flex;
    margin: auto;
    padding-left: 65px;
    .left {
      text-align: left;
      position: relative;
      .topTitle {
        color: #fff;
        font-family: Poppins, Poppins;
        font-weight: bold;
        font-size: 55px;
        width: 618px;
      }
      .vagueIcon {
        z-index: 1;
        position: absolute;
        top: 19%;
        left: 66%;
        img {
          width: 186px;
          height: 134px;
        }
      }
      ul {
        margin-top: 45px;
        li {
          margin-bottom: 45px;
          display: flex;
          .number {
            margin-right: 15px;
            color: #bfff71;
            font-size: 40px;
            font-style: italic;
            font-weight: bold;
          }
          .title {
            font-size: 20px;
            color: #fff;
            font-weight: bold;
            font-family: Poppins, Poppins;
          }
          .introduce {
            width: 430px;
            margin-top: 10px;
            font-size: 18px;
            color: #fff;
            font-family: Poppins, Poppins;
          }
        }
      }
    }
    .right {
      margin-left: -80px;
      margin-top: 150px;
      font-size: 20px;
      color: #fff;
      text-align: left;
      position: relative;
      .dialog {
        padding: 60px 40px 60px 60px;
        border-radius: 54px;
        background: linear-gradient(177deg, #4a23d8 0%, #3109cc 100%);
        .text {
          font-family: Poppins, Poppins;
          font-weight: bold;
          width: 470px;
          font-size: 30px;
          margin-bottom: 40px;
          margin-left: -20px;
        }
        .rp {
          width: 500px;
          padding: 35px;
          padding-right: 70px;
          background-color: #cff202;
          border-radius: 22px;
          margin-left: -15px;
          font-family: Poppins, Poppins;
          color: #4119d4;
          p {
            margin-bottom: 15px;
          }
          img {
            width: 347px;
            height: 59px;
          }
        }
        .jiantou {
          position: absolute;
          top: 17%;
          left: 72%;
          img {
            width: 180px;
            height: 180px;
          }
        }
      }
      .get {
        margin-top: 70px;
        display: flex;
        justify-content: space-evenly;
        img {
          width: 228px;
          height: 66px;
        }
      }
      .footer {
        text-align: center;
        font-size: 12px;
        margin-top: 32px;
        img {
          width: 160px;
          height: 55px;
        }
      }
    }
  }
  .advantage {
    background-image: url("~@/assets/advantageBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 1310px;
    padding: 73px 40px 0 110px;
    margin: auto;
    margin-top: 60px;
    .title {
      font-weight: bold;
      font-family: Poppins, Poppins;
      font-size: 40px;
      display: flex;
      justify-content: space-between;
      img {
        width: 256px;
        height: 59px;
      }
    }
    .box {
      margin-top: 20px;
      ul {
        display: flex;
        text-align: left;
        flex-wrap: wrap;
        li {
          width: 50%;
          margin-bottom: 50px;
          .boxTitle {
            color: #5931f5;
            font-weight: bold;
            font-family: Poppins, Poppins;
            font-size: 24px;
          }
          .boxContent {
            width: 310px;
            margin-top: 10px;
            line-height: 20px;
            font-family: Poppins, Poppins;
            font-size: 18px;
          }
        }
        li:nth-child(2) .boxContent {
          width: 250px;
        }
        li:nth-child(3) .boxContent {
          width: 325px;
        }
      }
    }
  }
  .loanProduct {
    margin: auto;
    margin-top: 60px;
    width: 1310px;
    padding: 70px 145px 120px 120px;
    background-color: #fff;
    border-radius: 54px;
    display: flex;
    .left {
      margin-top: 90px;
      font-family: Poppins, Poppins;
      text-align: left;
      .title {
        margin-bottom: 33px;
        font-size: 38px;
        font-weight: bold;
      }
      .choose {
        margin-top: 48px;
        font-size: 18px;
        width: 500px;
      }
      .icon {
        font-size: 15px;
        display: flex;
        margin-top: 57px;
        align-items: end;
        span {
          margin-right: 12px;
        }
        img {
          width: 51px;
          height: 51px;
          margin-right: 9px;
        }
      }
      .more {
        margin-top: 12px;
        font-size: 16px;
      }
    }
    .right {
      position: relative;
      margin-left: 40px;
      .quick {
        width: 550px;
        height: 500px;
      }
      p {
        position: absolute;
        top: 20%;
        left: 45%;
        font-size: 18px;
        font-family: Poppins, Poppins;
        color: #ffffff;
        z-index: 100;
      }
      .mobile {
        position: absolute;
        top: 10%;
        left: 40%;
        width: 260px;
        height: 550px;
      }
    }
  }
  .bottom {
    background-image: url("~@/assets/footerBg.png");
    background-size: 100% 100%;
    width: 1310px;
    margin: auto;
    margin-top: 148px;
    text-align: left;
    color: #cff202;
    padding: 38px 52px 38px 120px;
    display: flex;
    justify-content: space-between;
    .left {
      font-family: Poppins, Poppins;
      .logo {
        background: #ffffff;
        border-radius: 37px;
        padding: 7px 0px 7px 10px;
        width: 256px;
        height: 65px;
      }
      .title {
        margin-top: 37px;
        color: #fff;
        display: flex;
        width: 660px;
        border-bottom: 1px solid #fff;
        font-size: 24px;
        padding-bottom: 15px;
      }
      .about {
        font-size: 14px;
        margin-top: 5px;
        display: flex;
        p {
          width: 270px;
          line-height: 26px;
        }
      }
    }
    .right {
      margin-top: 119px;
      font-family: Poppins, Poppins;
      font-weight: bold;
      color: #cff202;
      font-size: 30px;
      width: 375px;
      margin-right: -40px;
      .rightImg {
        margin-top: 89px;
        text-align: center;
      }
      img {
        width: 222px;
        height: 65px;
      }
    }
  }
}
</style>
